<template>
  <div class="house-importer-change-tariffs-row">
    <div class="house-importer-change-tariffs-row__input">
      <app-v-select :options="options"
                    label="Название тарифа в ELSA"
                    select-label="name"
                    :reduce-function="opt => opt.id"
                    :clearable="false"
                    :searchable="true"
                    v-model="model.elsa_name"
      />
    </div>
    <div class="house-importer-change-tariffs-row__icon">
      <app-icon name="RightArrowIcon"/>
    </div>
    <div class="house-importer-change-tariffs-row__input">
      <app-v-select :options="kvartalTariffsX"
                    label="Название тарифа в Квартале"
                    select-label="name"
                    :reduce-function="opt => opt.name"
                    :clearable="false"
                    :searchable="true"
                    v-model="model.kvartal_name"
                    v-if="kvartalSelect"
      />

      <app-input label="Название тарифа в Квартале" v-model="model.kvartal_name" v-else/>
    </div>
    <div class="house-importer-change-tariffs-row__icon house-importer-change-tariffs-row__icon_delete"
         @click="$emit('delete')" v-if="canDelete">
      <app-icon name="TrashIcon"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ChangeTariffsRow",
    props: {
      kvartalTariffs: {},
      kvartalSelect: {
        type: Boolean,
        default: false
      },
      canDelete: {
        type: Boolean,
        default: true
      },
      tariffs: {},
      tariffsNames: {},
      value: {}
    },
    computed: {
      model: {
        get() {
          return this.value;
        },
        set(v) {
          this.$emit('input', v)
        }
      },
      kvartalTariffsX() {
        let selectedTariffs = this.tariffsNames.map(t => t.kvartal_name);
        return this.kvartalTariffs.filter(tariff => tariff === this.model.kvartal_name || !selectedTariffs.includes(tariff)).map((tariff, index) => ({
          name: tariff,
          id: index
        }));
      },
      options() {
        let selectedTariffs = this.tariffsNames.map(t => t.elsa_name);
        return this.tariffs.filter(tariff => tariff.id === this.model.elsa_name || !selectedTariffs.includes(tariff.id));
      }
    },
    watch: {
      'model.elsa_name'(newVal, oldVal) {
        if (oldVal === null) {
          if (!this.kvartalSelect) {
            let tariff = this.tariffs.find(t => t.id === newVal);
            this.model.kvartal_name = tariff.name;
          } else {
            let tariffName = this.tariffs.find(t => t.id === newVal).name;
            let kvartalTariff = this.kvartalTariffs.find(kvartalTariff => kvartalTariff.toLowerCase().trim() === tariffName.toLowerCase().trim());

            if (kvartalTariff) {
              this.model.kvartal_name = kvartalTariff;
            }

          }

        }
      }
    }
  }
</script>

<style lang="scss">
  .house-importer-change-tariffs-row {
    display: flex;
    align-items: center;

    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 15px;
      margin-top: 20px;

      &_delete {
        cursor: pointer;

        &:hover {
          color: rgba(var(--app-danger), 1);
        }
      }
    }

    .app-v-select-flat__label,
    .app-input__label{
      line-height: 1.1;
    }

    &__input {
      flex: 1;
    }
  }
</style>